import { DatePicker, Pagination } from 'antd'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { INTERBRANCH_MODAL_UPDATE } from '../../actions/type';
import { fetch_patients_details, fetch_interbranch_appointment_history } from "../../actions/InterBranchCoordinatorAction"
import Spinner from "react-bootstrap/Spinner";
import './appointmenthistory.css'
import ConsultationHistorydatePicker from '../ConsultationHistorydatePicker/ConsultationHistorydatePicker';
import { fetchSelectedAppointmentDetails } from '../../actions/AppointmentActions';
const { RangePicker } = DatePicker;

function InterBranchAppointmentHistory() {

    const dispatch = useDispatch()
    let reduxData = useSelector(state => state);
    // console.log("Redux Data in InterBranchAppointmentHistory: ", reduxData)
    const userData = useSelector(
        (state) => state.login.user
    );
    let userDetails = JSON.parse(localStorage.getItem("userData"));
    const userId = userDetails.profileId;
    // console.log("Co-ordinator Id: ", userId)
    let appointmentHistory = reduxData?.interBranchCoordinator?.interBranchAppointmentHistory;
    console.log("Appointment History: ", appointmentHistory)

    useEffect(() => {
        try {
            //Fetching the appointment history of the Co-ordinator (IMPORTANT -93579795 - for testing)
            dispatch(fetch_interbranch_appointment_history(userId, { date: new Date().toString() }));
        } catch (error) {
            console.log("Error in fetch_interbranch_appointment_history API", error);
        }
    }, [])


    let handleTableClick = (appointmentId) => {
        // console.log("Selected Apt Id ",appointmentId);
        // console.log("User Details:",userDetails)
        // console.log("User Data:",userData)
        dispatch(fetchSelectedAppointmentDetails({
            appointmentId: appointmentId ? appointmentId : null,
            userData
        }));

        dispatch({
            type: INTERBRANCH_MODAL_UPDATE,
            payload: { modalName: "consultationHistory", isVisible: true, data: { name: "name" } }
        })


    }

    let handleRangePicker = (range, dates) => {

        console.log(range, dates);
    }


    let handleDateBlockClick = (e) => {


        // console.log(e);
        // try {
        //     //Fetching the appointment history of the Co-ordinator (IMPORTANT -93579795 - for testing)
        //     dispatch(fetch_interbranch_appointment_history(userId,{date:new Date().toString()}));
        // } catch (error) {
        //     console.log("Error in fetch_interbranch_appointment_history API", error);
        // }
    }


    return (
        <div className='appontment-history-container'>    

            {
                appointmentHistory == undefined ? (                
                <div className='loader'
                style={{
                    width:"100%",
                    display:"flex",
                    flexDirection:"row",
                    alignItems:"center",
                    justifyContent:"center",
                    // marginTop:"15px"
                }}>
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>):
                appointmentHistory != null ?

                    <table className='appoinment-table'>
                        <tr>
                            <th>Appointment ID</th>
                            <th>Date/Time</th>
                            <th>Doctor Name</th>
                            <th>Patient Name</th>
                            <th>Consultation Status</th>
                            {/* <th>Next Steps</th> */}
                            <th></th>
                        </tr>

                        <tbody>
                            {
                                // appointmentHistory == undefined ? (
                                //     <div className='loader'>
                                //         <Spinner animation="border" role="status">
                                //             <span className="visually-hidden">Loading...</span>
                                //         </Spinner>
                                //     </div>) :

                                appointmentHistory != null ?
                                    appointmentHistory.map((element, key) => {
                                        return (
                                            <tr>
                                                <td >{element.appointmentId}</td>
                                                <td >{element.appointmentDate}</td>
                                                <td>{element.doctorName}</td>
                                                <td >{element.consultantName}</td>
                                                <td >{element.status}</td>
                                                {/* <td >
                                             Not Available
                                         </td> */}
                                                <td  ><button onClick={() => { handleTableClick(element.appointmentId) }} className='more-btn' >More</button></td>

                                            </tr>
                                        )
                                    })
                                    :
                                    ""



                            }
                        </tbody>
                    </table>

                    : <div className="no-appointments">Oops!! There is no appointments available for you.</div>
            }



            <div className="pagination-container">
                {/* <Pagination defaultCurrent={1} total={500} /> */}
            </div>

        </div>
    )
}

export default InterBranchAppointmentHistory
